module.exports = "<p>\n    signup works!\n</p>"